var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavedSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "url(#pattern0_2_15144)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2_15144",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_15144",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_15144",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAES0lEQVR4nO2dyWsUQRSHP5IYJxhX4kFQUAMS/wHxahR3r24HLy4hgnrWowcdb64JSEDExIsnjSR4NmIkEvTgdnJJYlQGd0HFZKS0BNGp6u6a7ppOz/vBgxC66xUfb169elWZgEgkEolEIpFIJBKJRCJRdSkHHALuAJ+BohhFzWIQOAhMLxfyQuC+gCUouO5pVs6RLJCJBNspslW6kDRBJAYHXECrnCygicTgtgvoTwKaqIGmmEWWRDNODAQ0foJHQCOgyVKakohGQFPpKJSIpvLgJHVQeaiSoxHQVDriJKKpPCRJHVRhjhb9loD2JAHtSQLakwS0JwloTxLQniSgPUlAVxPoeuAE8BIYA/L6d2Ge97mLCzO3JPjENlC+xHv5iM/7tLxnPrENVCoyxyM+79PGPfOJbaAxw8c0yvNJ2GvgCnAYWAcsBxboe4ZTEnSpVHA84vNx2XugA1gF1BKfUgG6XsMbi7AY5mOO7DfAEWA2ySgVoKtBJ4EfAtqPVgJPJaL9aC5wQ1LH/2oG9gOXgWGgAHzXVtC/6wHagaWE0zTgouRoflUbO4BbERfUSWAA2B6iYqkBLlHFi+Fa4HEMVcxDYHWAr7os9jpeAHMsYzYA5xOoyzsdNzhTstcxGRBd84GhBCD/MfX3PU2kAHTSW/BTAZAfJQj571TSlGXQ7y0poyFkJKu0cwZYD7QAM7SpnzcAZ4GREOMMxpFG0trrOGoZJygnjwJ7QvY81MK2N0QQqD5KxUAn1ev4AMyzVBe2d68CMx04qHeuBYzdSoVA+1ZtQAl3Wte5rqrRqcY0/oNyOoNTCfROy3z7YmqP1uhPhcnP1moAfcuSk13ShUmzLLX+zayDbtZ1dam57k7A3z6DLzWHxVkGvd9SwsV5ovJ3NTJq8NmWZdCXDfNUi1dSOmfw2Z1l0MOGeaqNR1LaZPB5N8ugC4Z5LkvQZ4vlnDKzoL8Z5tmYoM9Gg8+v1Qh6ZoI+Z1m+OSyzoAspSh3Psgx6OEWLoeocZhZ0j2GeqtWZlDoMPruyDLrdMM8R1zO8MjYsu7IMeqllC676yXGrzeBrAlgUJ+hK2VtLT3vA8M5YzNXHbH3Ft5SvftdBiym0jYa5bre80x9jm7TX4mez68DFFNoFw1xr9WFp0dL3KLfxf9Yy/lA54xdTaB8tR1lrAt7t1RsNl3Rx3TKuys0rXCGnFXQx4HC2M+Ddl7qfHKYaqdMLnykn/7En5Z6EF1Nq7yzXDXIhv7x2VNfCG/WfVzRqW643Ix2WEs60DsR6e2kqqCkgXydlfdUKe1Bg+1HOslV2tQmdkyWyS6hV37soF/KQri5yOicL7BJSNe42fSVgMmIEK6hb/qmTczonC2yLluiyrVuf8RX04cEX4LmO3C7dILL1LsLCLvtfh4gQ2D4VJrJtN2lFEVQfcOP0VZTBRO6wbZfwRQ6abkgjx1wGExEIW+Vk1cBSpn6u/wncxVpARmEsEgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedSearch);
export default __webpack_public_path__ + "static/media/saved_search.370093bfc021dbfff7ce6d5875986de3.svg";
export { ForwardRef as ReactComponent };